import { debounce } from '../../functions/debounce';
import { createListItemHtml } from './createListItemHtml';
import { addStatusText } from './statusText';
export default function autocomplete(searchForm) {
    let currentFocus;
    const searchInput = searchForm.getElementsByTagName('input')[0];
    const searchButton = searchForm.querySelector('[data-search-button]');
    const clearInputButton = searchForm.querySelector('[data-clear-input]');
    const status = searchForm.querySelector('[data-status]');
    const statusText = status.dataset.statustext;
    const statusJson = statusText && JSON.parse(statusText);
    clearInputButton.addEventListener('click', () => {
        searchInput.value = '';
        searchInput.focus();
    });
    const getDataFromApi = async (prefix) => {
        if (prefix != '') {
            const searchActionUrl = searchForm.querySelector('form')?.getAttribute('action');
            await fetch(`${searchActionUrl}/Suggest?prefix=${prefix}`)
                .then(response => response.json())
                .then(json => {
                const suggestions = json.hits.map((hit) => hit.query);
                if (suggestions.length > 0) {
                    createList(suggestions, prefix);
                }
            })
                .catch(error => {
                console.log('error', error);
            });
        }
    };
    function createList(items, inputValue) {
        let listElement;
        let listHasItems = false;
        currentFocus = -1;
        const listContainer = document.getElementById(`${searchInput.id}autocomplete-list-container`);
        let list = searchForm?.querySelector(`#${searchInput.id}autocomplete-list`);
        const ul = document.createElement('ul');
        const autocompleteSearchSuggestions = listContainer?.dataset.suggestions;
        ul.id = searchInput.id + 'autocomplete-list';
        ul.setAttribute('role', 'listbox');
        ul.setAttribute('aria-label', autocompleteSearchSuggestions || '');
        function filterItems(arr, query) {
            return arr.filter((item) => item.substring(0, query.length).toUpperCase() == query.toUpperCase());
        }
        const filteredItems = filterItems(items, inputValue);
        if (!list) {
            listContainer?.appendChild(ul);
            list = searchForm?.querySelector(`#${searchInput.id}autocomplete-list`);
        }
        while (list?.firstChild) {
            list?.removeChild(list.firstChild);
        }
        filteredItems.forEach((item, index) => {
            if (item.substring(0, inputValue.length).toUpperCase() == inputValue.toUpperCase()) {
                listHasItems = true;
                listElement = createListItemHtml({
                    item: item,
                    inputValue: inputValue,
                    setsize: filteredItems.length,
                    posinset: index,
                });
                listElement.addEventListener('click', function () {
                    searchInput.value = this.dataset.value || '';
                    searchButton.click();
                });
                searchInput.setAttribute('aria-expanded', 'true');
                list?.appendChild(listElement);
            }
        });
        if (listHasItems) {
            searchForm?.classList.add('spv-autocomplete--hasDropdown');
        }
        status.innerText = filteredItems.length
            ? addStatusText.availableOptions(filteredItems.length, statusJson)
            : '';
    }
    const checkInput = (value) => {
        const fieldVal = value;
        closeAllLists();
        if (!fieldVal) {
            searchForm.classList.remove('spv-autocomplete--hasValue');
            return;
        }
        searchForm.classList.add('spv-autocomplete--hasValue');
        getDataFromApi(fieldVal);
    };
    searchInput.addEventListener('input', debounce(e => {
        const target = e.target;
        return checkInput(target.value);
    }));
    searchInput.addEventListener('focus', debounce(e => {
        const target = e.target;
        checkInput(target.value);
    }));
    function handlePrintableKey(event) {
        const inputElement = searchInput;
        const eventIsOnInput = event.target === inputElement;
        if (!eventIsOnInput) {
            inputElement.focus();
        }
    }
    function handleUpArrow(event, list) {
        event.preventDefault();
        currentFocus--;
        addActive(list);
    }
    function handleDownArrow(event, list) {
        event.preventDefault();
        currentFocus++;
        addActive(list);
    }
    function handleSelectItem(e, list) {
        if (currentFocus > -1) {
            e.preventDefault();
            if (list)
                list[currentFocus].click();
        }
    }
    function handleComponentBlur(e) {
        e.stopImmediatePropagation();
        closeAllLists();
    }
    function handleKeyDown(event) {
        const autocompleteList = (document.getElementById(searchInput.id + 'autocomplete-list'));
        let autocompleteListItems;
        if (!autocompleteList) {
            return;
        }
        else {
            autocompleteListItems = autocompleteList.getElementsByTagName('li');
        }
        switch (event.code) {
            case 'ArrowUp':
                handleUpArrow(event, autocompleteListItems);
                break;
            case 'ArrowDown':
                handleDownArrow(event, autocompleteListItems);
                break;
            case 'Space':
                handleSelectItem(event, autocompleteListItems);
                break;
            case 'Enter':
                handleSelectItem(event, autocompleteListItems);
                break;
            case 'Escape':
                handleComponentBlur(event);
                break;
            default:
                if (event.code !== 'Tab') {
                    handlePrintableKey(event);
                }
                break;
        }
    }
    function addActive(autocompleteList) {
        if (!autocompleteList)
            return;
        removeActive(autocompleteList);
        if (currentFocus >= autocompleteList.length)
            currentFocus = 0;
        if (currentFocus < 0)
            currentFocus = autocompleteList.length - 1;
        searchInput.setAttribute('aria-activedescendant', 'spv-autocomplete__dropdownItem_' + currentFocus);
        const currentItem = autocompleteList[currentFocus];
        currentItem.classList.add('spv-autocomplete__dropdownItem--active');
        currentItem.setAttribute('aria-selected', 'true');
        currentItem.focus();
        status.innerText = addStatusText.selectedOption(currentItem.innerText, currentFocus, autocompleteList.length, statusJson);
    }
    function removeActive(autocompleteList) {
        for (let i = 0; i < autocompleteList.length; i++) {
            autocompleteList[i].classList.remove('spv-autocomplete__dropdownItem--active');
            autocompleteList[i].removeAttribute('aria-selected');
        }
    }
    function closeAllLists() {
        status?.innerText && (status.innerText = '');
        searchForm?.classList.remove('spv-autocomplete--hasDropdown');
        const listContainer = document.getElementById(`${searchInput.id}autocomplete-list-container`);
        if (listContainer) {
            listContainer.innerHTML = '';
        }
        searchInput.setAttribute('aria-expanded', 'false');
    }
    searchForm.addEventListener('keydown', e => handleKeyDown(e));
}
//# sourceMappingURL=lazy-autocomplete.js.map